export const staticImageSet = new Set<string>([
  '/images/Baseball Cap.webp',
  '/images/Coffee Mug.webp',
  '/images/Dog Bowls.webp',
  '/images/Gentleman Hound.webp',
  '/images/logo-80-light.webp',
  '/images/logo-80.webp',
  '/images/logo-160-light.webp',
  '/images/logo-160.webp',
  '/images/World Coffee Map.webp',
  '/images/badges/artScene.webp',
  '/images/badges/backstagePass.webp',
  '/images/badges/Be Thankful.webp',
  '/images/badges/bookworm.webp',
  '/images/badges/brewmaster.webp',
  '/images/badges/chainBreaker.webp',
  '/images/badges/coffeeHouse.webp',
  '/images/badges/coffeeSocialite.webp',
  '/images/badges/coffeeTourist.webp',
  '/images/badges/Dick Clark.webp',
  '/images/badges/earlyBird.webp',
  '/images/badges/explorer.webp',
  '/images/badges/firstCheckin.webp',
  '/images/badges/firstReview.webp',
  '/images/badges/folkHero.webp',
  '/images/badges/gameDaySipper.webp',
  '/images/badges/givebackBrewer.webp',
  '/images/badges/globalExplorer.webp',
  '/images/badges/jazzCat.webp',
  '/images/badges/liveMusic.webp',
  '/images/badges/localArtistSupporter.webp',
  '/images/badges/loyalRegular.webp',
  '/images/badges/Luck O\' The Irish.webp',
  '/images/badges/marketMaven.webp',
  '/images/badges/micDrop.webp',
  '/images/badges/myPup.webp',
  '/images/badges/neighborhoodAdventurer.webp',
  '/images/badges/nightOwl.webp',
  '/images/badges/openStage.webp',
  '/images/badges/Pumpkin Spice Season.webp',
  '/images/badges/Puppy Love.webp',
  '/images/badges/roasterRegular.webp',
  '/images/badges/scout.webp',
  '/images/badges/Seasons Greetings.webp',
  '/images/badges/superDog.webp',
  '/images/badges/supportLocal.webp',
  '/images/badges/topReviewer.webp',
  '/images/badges/Trick-Or-Treat.webp',
  '/images/badges/weekendWarrior.webp',
  '/images/badges/welcome.webp',
  '/images/badges/wordsmith.webp',
  '/images/coffee mug test.jpg',
  '/images/coffee-beans.webp',
  '/images/coffee-shops/roasting beans.webp',
  '/images/general/marker-icon.webp',
  '/images/general/marker-shadow.webp',
  '/images/placeholder-logo.webp',
  '/images/placeholder-user.webp',
]);

export function hasStaticImage(path: string): boolean {
  if (!path) return false;
  const normalized = path.replace(/^\.\//, '').replace(/\/+/g, '/');
  const withLeadingSlash = normalized.startsWith('/')
    ? normalized
    : `/${normalized}`;
  return staticImageSet.has(withLeadingSlash);
}
